import { render, staticRenderFns } from "./LocalizedTextEditor.vue?vue&type=template&id=ad7e7fd8&scoped=true"
import script from "./LocalizedTextEditor.vue?vue&type=script&lang=js"
export * from "./LocalizedTextEditor.vue?vue&type=script&lang=js"
import style0 from "./LocalizedTextEditor.vue?vue&type=style&index=0&id=ad7e7fd8&prod&lang=scss&scoped=true"
import style1 from "./LocalizedTextEditor.vue?vue&type=style&index=1&id=ad7e7fd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7e7fd8",
  null
  
)

export default component.exports